import { combineReducers } from 'redux';

import artworkDataReducer from './artworkDataReducer';
import navigationReducer from './navigationReducer';
import applyCodesReducer from './applyCodesReducer';
import customizeReducer from './customizeReducer';
import whiteInkOptionsReducer from './whiteInkOptionsReducer';
import spinnerReducer from './spinnerReducer';
import uploadReducer from './uploadReducer';
import headerReducer from './headerReducer';
import footerReducer from './footerReducer';
import popupsReducer from './popupsReducer';
import helpReducer from './helpReducer';
import authReducer from './authReducer';

export default combineReducers({
  applyCodes: applyCodesReducer,
  customize: customizeReducer,
  whiteInkOptions: whiteInkOptionsReducer,
  artwork: artworkDataReducer,
  matrix: navigationReducer,
  spinner: spinnerReducer,
  upload: uploadReducer,
  header: headerReducer,
  footer: footerReducer,
  popups: popupsReducer,
  help: helpReducer,
  auth: authReducer,
});
